import { render, staticRenderFns } from "./CellTherapy.vue?vue&type=template&id=3a6c617f&scoped=true&"
var script = {}
import style0 from "./CellTherapy.vue?vue&type=style&index=0&id=3a6c617f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6c617f",
  null
  
)

export default component.exports